module.exports = __webpack_public_path__ + "img/pop_wallet_logo_huobiWallet@2x.427ea7f3.png";